import * as React from 'react';
import { CLASS_MY_WORK_CARD } from '../../../constants';
import { ICardNameProps } from './types';
import './_CardName.scss';
import { Tooltip } from 'kui';
import { escape } from 'underscore';
import { clearMarkdownInline } from '../../../../../base/helpers/clearMarkdownHelper';
import ReactHtmlParser from 'react-html-parser';
import { markdown } from '../../../../../../../helper/markdownHelper';
import { AnalyzeRender } from '../../../../../helpers/memoizeHelper';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`myWork CardName`) : null;

export function CardName({
    card
}: ICardNameProps) {
    if (analyzeRender) analyzeRender.call(card.cardId);
    const className = CLASS_MY_WORK_CARD + '__main-info';

    const [name, setName] = React.useState('');
    React.useEffect(() => {
        setName(escape(clearMarkdownInline(card.cardFullName)));
    }, [card.cardFullName]);

    return (
        <div className={className}>
            <div className={className + '-name-wrapper'}>
                <div className={className + '-name'}>
                    <Tooltip value={name} direction={'up-right'} className={className + '-name-tooltip'}>
                        <span>{ReactHtmlParser(markdown(card.cardFullName))}</span>
                    </Tooltip>
                </div>
            </div>
        </div>
    )
}
